import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getAllocatedHours } from "../../../../store/actions/masterData.action";
import { useFormik } from "formik";
import { useSelector } from "react-redux";
import * as Yup from 'yup';
import { ActionUpdateById } from "../../../../store/actions/CommonAction";
import { Inputform } from "../../../forms-component/InputForm";
import { Button, useColorMode } from "theme-ui";
import theme from "../../../../theme";
const EditAllocatedHours = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { allocatedHours } = useSelector((state: any) => state.masterData);
    const allocatedHoursId = allocatedHours?.data?.[0]?._id;

    const [isEditing, setIsEditing] = useState(!!allocatedHoursId);

    useEffect(() => {
        // if (allocatedHoursId) {
        setIsEditing(true);
        dispatch(getAllocatedHours());
        // }
    }, [dispatch]);
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            allocatedHours: isEditing ? (allocatedHours?.data?.[0]?.allocatedHours || '') : ''
        },
        validationSchema: Yup.object().shape({
            allocatedHours: Yup.number()
                .typeError('Allocated Hours must be a number')
                .required('Allocated Hours is required')

        }),
        onSubmit: (values, { resetForm }) => {

            const handleResponse = (res: any) => {
                if (res.status) {
                    resetForm();
                    navigate("/allocated-hours");
                }
            };
            if (allocatedHoursId) {
                dispatch(ActionUpdateById({ Query: `/allocatedHours/editAllocatedHours/${allocatedHoursId}`, obj: values }, handleResponse));
            }
        },
    });

    const { handleSubmit, setFieldValue, values, handleBlur, touched, errors } = formik;
    const [colorMode] = useColorMode();
    const titleHeader = colorMode === 'light' ? "#0a0a0a" : "#dadada";

    return (
        <div className="main-content p-5">
            <form onSubmit={handleSubmit}>
                <h1 style={{ color: titleHeader }}>Edit Allocated Hours</h1>
                <div className="row">
                    <div className="col-md-6 mt-4">
                        <Inputform
                            label={"Allocated Hours"}
                            Placeholder={"Enter Allocated Hours"}
                            Name={"allocatedHours"}
                            type='number'
                            sx={{ color: titleHeader }}
                            Title_sx={{ color: "grey3" }}
                            touched={touched?.allocatedHours}
                            asterisk={true}
                            errors={errors?.allocatedHours}
                            values={values?.allocatedHours || ''}
                            onBlur={handleBlur}
                            OnChange={(event: any) => {
                                const value = event.target.value;
                                if (/^\d*$/.test(value)) {
                                    setFieldValue("allocatedHours", value, true);
                                }
                            }}
                        />
                    </div>
                </div>
                <div className='row mt-5'>
                    <div className='col-md-4'>
                        <Button
                            type="reset"
                            sx={{ border: `1px solid ${theme.colors?.primary || 'defaultBorderColor'}`, background: 'white', color: theme.colors?.muted, borderRadius: '12px', padding: [2, 4, 2, 4], width: '95%' }}
                            onClick={() => navigate(-1)}
                        >
                            Cancel
                        </Button>
                    </div>
                    <div className='col-md-4'>
                        <Button sx={{ borderRadius: '12px', padding: [2, 4, 2, 4], width: '95%' }} type='submit'>
                            Submit
                        </Button>
                    </div>
                </div>
            </form>
        </div >
    )
}

export default EditAllocatedHours